import React from 'react'
import { useField } from 'formik'
import { startOfMonth, endOfMonth } from 'date-fns'
import DateRangePicker, { DateRangePickerProps } from 'uiComponents/popups/comparisonDateRangePicker'
import FieldWrapper from '../fieldWrapper'
import { useCustomId, useGetComponentState } from '../_shared/hooks'
import { parseISODate } from 'utils/dates'
import { LucideIconName } from 'utils/lucideIcon'
import { DateRange } from 'dateRanges'

interface DateRangeFieldFormikProps
    extends Omit<DateRangePickerProps, 'onChange' | 'range' | 'navigation' | 'match' | 'theme'> {
    name: string
    id?: string
    label?: string
    icon?: LucideIconName
    defaultValue?: Pick<DateRange, 'from' | 'to'>
}

const DateRangeFieldFormik: React.FC<DateRangeFieldFormikProps> = ({
    name,
    id,
    label,
    icon,
    defaultValue = { from: startOfMonth(new Date()), to: endOfMonth(new Date()) },
    ...props
}) => {
    const [{ value }, { error }, { setValue }] = useField(name)
    const innerId = useCustomId(id)
    const state = useGetComponentState(name)

    return (
        <FieldWrapper id={innerId} status={state} label={label} icon={icon} error={error}>
            <div style={{ position: 'relative' }} className="date-picker">
                <DateRangePicker
                    {...props}
                    range={{
                        from: parseISODate(value?.from ?? defaultValue.from),
                        to: parseISODate(value?.to ?? defaultValue.to),
                        name: 'custom',
                        period: 'day',
                    }}
                    onChange={({ from, to }: { from: Date; to: Date }) => {
                        setValue({ from: from.toISOString(), to: to.toISOString() })
                    }}
                    style={{ zIndex: 2, top: 'unset' }}
                />
            </div>
        </FieldWrapper>
    )
}

export default DateRangeFieldFormik
